import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  appInfoCalledBy,
  findAppInfoTableContentIndexByAppId,
  getUsersForAppInfoTabPendingState,
  getUsersForAppInfoTabRejectedState,
  getUsersForAppInfoTabSuccessState,
} from "../../pages/applications/applicationDetail/tabs/static/appInfo/model";
import {
  getUsersForOwnersTablePendingState,
  getUsersForOwnersTableRejectedState,
  getUsersForOwnersTableSuccessState,
  membersKey,
  userGroupInfoCalledBy,
} from "../../pages/userGroups/userGroupDetails/userGroupInfo/model";
import * as service from "./service";
import { PEV } from "../../common/utils";

const initialState = {
  appInfoTableContent: [],
  userGroupUserInfoTableContent: {},
};

const getInfoTabUsersTableContent = createAsyncThunk(
  "infoTab/users",
  async (InfoTabOptionsObject) => {
    return await service.getInfoTabUsersTableContents(InfoTabOptionsObject.usersList);
  }
);

const getUserGroupMembersTableContent = createAsyncThunk("infoTab/members", async (userGroupId) => {
  return await service.getInfoTabMembersTableContents(userGroupId);
});

export const InfoTabUsersTableContentSlice = createSlice({
  name: "InfoTabUsersList",
  initialState,
  reducers: {
    setUpGaaAndAoDataSourceAndEmails(state, action) {
      const { appId, gaaEmail, aoEmail, gaaDataSource, aoDataSource } = action.payload;
      const appInfoTableContentIndex = findAppInfoTableContentIndexByAppId(state, appId);
      state.appInfoTableContent[appInfoTableContentIndex].copyGaaEmails = gaaEmail;
      state.appInfoTableContent[appInfoTableContentIndex].copyAoEmails = aoEmail;
      state.appInfoTableContent[appInfoTableContentIndex].gaaDataSource = gaaDataSource;
      state.appInfoTableContent[appInfoTableContentIndex].aoDataSource = aoDataSource;
    },
  },
  extraReducers: {
    [getInfoTabUsersTableContent.pending.type]: (state, pendingAction) => {
      const calledBy = pendingAction.meta.arg.calledBy;
      if (calledBy === appInfoCalledBy) {
        getUsersForAppInfoTabPendingState(state, pendingAction);
      } else if (calledBy === userGroupInfoCalledBy) {
        getUsersForOwnersTablePendingState(state, pendingAction);
      }
    },
    [getInfoTabUsersTableContent.fulfilled.type]: (state, action) => {
      const calledBy = action.meta.arg.calledBy;
      if (calledBy === appInfoCalledBy) {
        getUsersForAppInfoTabSuccessState(state, action);
      } else if (calledBy === userGroupInfoCalledBy) {
        getUsersForOwnersTableSuccessState(state, action);
      }
    },
    [getInfoTabUsersTableContent.rejected.type]: (state, rejectedAction) => {
      const calledBy = rejectedAction.meta.arg.calledBy;
      if (calledBy === appInfoCalledBy) {
        getUsersForAppInfoTabRejectedState(state, rejectedAction);
      } else if (calledBy === userGroupInfoCalledBy) {
        getUsersForOwnersTableRejectedState(state, rejectedAction);
      }
    },
    [getUserGroupMembersTableContent.pending.type]: (state, pendingAction) => {
      const userGroupId = pendingAction.meta.arg;
      state.userGroupUserInfoTableContent[userGroupId] = {
        ...state.userGroupUserInfoTableContent?.[userGroupId],
      };
      state.userGroupUserInfoTableContent[userGroupId][membersKey] = PEV(
        {},
        `Fetching User Group ${membersKey} table Content`
      );
    },
    [getUserGroupMembersTableContent.fulfilled.type]: (state, action) => {
      const userGroupId = action.meta.arg;
      state.userGroupUserInfoTableContent[userGroupId][membersKey] = PEV(action.payload);
    },
    [getUserGroupMembersTableContent.rejected.type]: (state, rejectedAction) => {
      const userGroupId = rejectedAction.meta.arg;
      state.userGroupUserInfoTableContent[userGroupId][membersKey] = PEV(
        {},
        null,
        `Error while fetching User Group ${membersKey} table`
      );
    },
  },
});

export const InfoTabUsersTableContentReducer = InfoTabUsersTableContentSlice.reducer;
const { setUpGaaAndAoDataSourceAndEmails } = InfoTabUsersTableContentSlice.actions;

export const InfoTabUsersTableContentActions = {
  getInfoTabUsersTableContent,
  getUserGroupMembersTableContent,
  setUpGaaAndAoDataSourceAndEmails,
};
